<ag-grid-angular
    style="width: 100%; height: 100%;"
    class="ag-theme-balham"
    [context]="gridContext"
    [components]="gridComponents"
    [columnDefs]="gridOptions.columnDefs"
    [rowData]="store.tableData()"
    [defaultColDef]="gridOptions.defaultColDef"
    [excelStyles]="excelStyles"
    [statusBar]="gridOptions.statusBar"
    [suppressPaginationPanel]="true"
    [pagination]="true"
    [paginationPageSize]="gridOptions.paginationPageSize"
    [paginationPageSizeSelector]="gridOptions.paginationPageSizeSelector">
</ag-grid-angular>